import React, { useEffect, useRef, useState } from 'react';
import { getLocalStorageItem, useOutsideClick } from '../../utils/helper';
import { useNavigate } from 'react-router-dom';
import dummyVideoImage from '../../assets/images/video-image.jpg';

const VideoCard = ({ item, categoriesList, Id, setId }) => {
  const sureyRef = useRef(null);
  const navigate = useNavigate();
  const [userType, setUserType] = useState(null);
  // const [imageError, setImageError] = useState(true);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const redirectUrl = userData?.slug
    ? `/${userData?.slug}/health-videos/view-health-video`
    : `/health-videos/view-health-video`;

  const [selectedCategory, setSelectedCategory] = useState([]);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsedData = JSON.parse(userData);
      setUserType(parsedData.userType);
    }
  }, []);

  useEffect(() => {
    if (item.category_ids) {
      const selectCategory = categoriesList.filter((category) =>
        item.category_ids.includes(category._id)
      );
      setSelectedCategory(selectCategory);
    }
  }, [item.category_ids, categoriesList]);

  useOutsideClick(sureyRef, () => {
    if (Id === item?.id) setId('');
  });

  // const checkImageAccess = async (url) => {
  //   try {
  //     const response = await fetch(url, { method: 'HEAD' });
  //     if (response.ok) {
  //       setImageError(false);
  //     } else {
  //       setImageError(true);
  //     }
  //   } catch (error) {
  //     setImageError(true);
  //   }
  // };

  // useEffect(() => {
  //   if (item.thumbnail_image_url) {
  //     checkImageAccess(item.thumbnail_image_url);
  //   }
  // }, [item?.thumbnail_image_url]);

  return (
    <div
      className="w-full cursor-pointer"
      onClick={() => navigate(`${redirectUrl}?id=${item?._id}`)}
    >
      <div className="relative bg-[#F4F4F4] dark:bg-shoorah-gray6 rounded-2xl overflow-hidden">
        {item.thumbnail_image_url ? (
          <>
            <img
              src={item.thumbnail_image_url}
              alt="survey"
              className="object-cover w-full h-[300px]"
            />
            <div className=" absolute bottom-1 right-0 flex flex-row justify-end">
              <div className="px-3 py-1 m-3 bg-shoorah-active rounded-3xl w-fit text-white">
                {item.duration}
              </div>
            </div>
          </>
        ) : (
          <div className="flex justify-center items-center h-[300px]">
            <img src={dummyVideoImage} alt="survey placeholder" className="w-full" />
          </div>
        )}
      </div>

      <div className="h-fit flex flex-col lg:gap-4 gap-2 lg:px-4 px-3 lg:py-6 py-4">
        <div className="flex justify-between items-center">
          <p className="lg:text-[20px] text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg font-bold leading-6 truncate max-w-[80%]">
            {item?.display_name}
          </p>
        </div>
        <div className="flex flex-row">
          <p className="lg:text-[16px] w-max text-[14px] text-shoorah-lightBlack dark:text-shoorah-darkBg font-normal leading-5 truncate">
            {selectedCategory.map((category) => category.name).join(', ')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
